import { render, staticRenderFns } from "./createBpage.vue?vue&type=template&id=05a677ba&scoped=true"
import script from "./createBpage.vue?vue&type=script&lang=js"
export * from "./createBpage.vue?vue&type=script&lang=js"
import style0 from "./createBpage.vue?vue&type=style&index=0&id=05a677ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a677ba",
  null
  
)

export default component.exports